import { useCallback, useState } from "react";

type State = {
  isMemberGetMemberDrawerOpen: boolean;
  isUserProfileDrawerOpen: boolean;
};

const initialState: State = {
  isMemberGetMemberDrawerOpen: false,
  isUserProfileDrawerOpen: false,
};

export const useLayoutViewModel = () => {
  const [state, setState] = useState(initialState);

  const handleCloseMemberGetMemberDrawer = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isMemberGetMemberDrawerOpen: false,
    }));
  }, []);

  const handleOpenMemberGetMemberDrawer = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isMemberGetMemberDrawerOpen: true,
    }));
  }, []);

  const handleCloseUserProfileDrawer = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isUserProfileDrawerOpen: false,
    }));
  }, []);

  const handleOpenUserProfileDrawer = useCallback(() => {
    setState((prev) => ({
      ...prev,
      isUserProfileDrawerOpen: true,
    }));
  }, []);

  return {
    ...state,
    handleCloseMemberGetMemberDrawer,
    handleCloseUserProfileDrawer,
    handleOpenMemberGetMemberDrawer,
    handleOpenUserProfileDrawer,
  };
};
